import { useMemo } from 'react';

import { getUserByExternalId, useUsersStore } from '../../stores';

export const useUsers = () => {
  const { updateUsers, userMap } = useUsersStore();

  const users = useMemo(() => Array.from(userMap.values()), [userMap]);

  return { getUserByExternalId, updateUsers, users };
};
